import React from "react";
import Cookies from "universal-cookie";
import createDbUser from '../services/createDbUser';
import { NineCellLoading } from 'react-loadingg';
import translateString from "../utils/Locales";
import Utils from "../utils/utils";

let t = translateString;

export default class NewUserWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isWorking: false, 
            username: '', 
            password: '', 
            confirm: '', 
            selectedType: 0,
            error: false,
            errorMessage: t('impossibile_soddifsare'),
        };
    }

    dataIsCorrect() {
        return (this.state.username != '' && /^[-a-zA-Z0-9!@#$&()`.+,/\"]+$/.test(this.state.username)
                && this.state.password != '' && this.state.password == this.state.confirm && /^[-a-zA-Z0-9!@#$&()`.+,/\"]+$/.test(this.state.password));
    }

    async createUser() {

        // Check inserted data
        if (this.dataIsCorrect()) {

            this.setState({ isWorking: true });
            
            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });

            // Create user
            let res = await createDbUser(username, token, this.state.username, this.state.password, this.state.selectedType);
            
            if (res != null && res.result == 'ok') {
                this.props.onCancel();
                Utils.showSuccess(t('utente') + ' ' + this.state.username + ' ' + t('creato_succ'));
            } else if (res != null) {
                if (res.result == 'KO' && res.description.includes('username')) {
                    this.setState({ isWorking: false, error: true, errorMessage: t('username_preso') });
                    setTimeout(() => {
                        this.setState({ error: false });
                    }, 2000);
                    return;
                } else {
                    this.setState({ isWorking: false, error: true, errorMessage: t('impossibile_soddifsare') });
                    setTimeout(() => {
                        this.setState({ error: false });
                    }, 2000);
                    return;
                }
            } else {
                this.setState({ isWorking: false, error: true, errorMessage: t('impossibile_soddifsare') });
                setTimeout(() => {
                    this.setState({ error: false });
                }, 2000);
                return;
            }

        } else {
            this.setState({ error: true, errorMessage: t('verifica_dati') });
            setTimeout(() => {
                this.setState({ error: false });
            }, 2000);
            return;
        }
    }

    render() {

        return (
            <div style={backView} onClick={() => this.props.onCancel() }>
                <div style={mainView} onClick={(e) => e.stopPropagation() }>
                    { this.state.isWorking ? <NineCellLoading /> : (
                        <div>
                            <div style={{ textAlign: 'end' }}>
                                <img alt="" src={ require('../images/close_icon.png') } style={{ alignSelf: 'flex-end', width: 30, height: 30, marginTop: 30, marginRight: 30, cursor: 'pointer' }} onClick={this.props.onCancel} />
                            </div>  
                            <p style={{ textAlign: 'center', width: '100%', marginTop: '-10px', fontSize: 24, fontFamily: 'Teko', fontWeight: 'bold' }}>{t('nuovo_utente')}</p>
                            <p style={{ textAlign: 'center', width: '100%', marginTop: '-15px', marginBottom: '15px', fontSize: 14, fontFamily: 'Teko' }}>{t('nuovo_utente_info')}</p>                      
                            { this.state.error && <p style={{ textAlign: 'center', width: '100%', marginTop: '-15px', marginBottom: '15px', fontSize: 14, fontFamily: 'Teko', color: 'red' }}>{this.state.errorMessage}</p> }
                            <div style={{ display: 'flex', width: '90%', marginLeft: '7%', marginBotttom: '20px' }}>
                                <div style={{ width: '50%' }}>
                                    <input type='text' name='username' style={{ width: '90%' }} placeholder={'Username'} value={this.state.username} onChange={(e) => this.setState({ username: e.target.value })} className="inputCustom" /><br/>
                                    <input type='password' name='password' style={{ width: '90%', marginTop: 7 }} placeholder={'Password'} value={this.state.password} onChange={(e) => this.setState({ password: e.target.value })} className="inputCustom" /><br/>
                                    <input type='password' name='r_password' style={{ width: '90%', marginTop: 7 }} placeholder={t('conferma_pwd')} value={this.state.confirm} onChange={(e) => this.setState({ confirm: e.target.value })} className="inputCustom" /><br/>
                                </div>
                                <div style={{ width: '50%', textAlign: 'left', paddingLeft: '5px' }}>
                                    <p style={{ textAlign: 'left', width: '100%', marginBottom: '15px', fontSize: 16, fontFamily: 'Teko', paddingRight: '10px' }}>{t('utente_privilegi')}</p>                  
                                    <input type="radio" name="user_type" value={0} checked={true} style={{ marginLeft: '0px' }} onChange={(e) => this.setState({ selectedType: 0 })} /> <label style={{ fontSize: 16, fontFamily: 'Teko', fontWeight: 'bold' }}>{t('amministratore')}</label><br/>
                                    <p style={{ textAlign: 'left', width: '100%', marginBottom: '5px', fontSize: 12, paddingRight: '10px' }}>{t('utente_amm_info')}</p><br/>                   
                                    <input type="radio" name="user_type" value={4} style={{ marginLeft: '0px' }} onChange={(e) => this.setState({ selectedType: 4 })} /> <label style={{ fontSize: 16, fontFamily: 'Teko', fontWeight: 'bold' }}>{t('fatturazione')}</label><br/>
                                    <p style={{ textAlign: 'left', width: '100%', marginBottom: '5px', fontSize: 12, paddingRight: '10px' }}>{t('utente_bil_info')}</p>
                                </div>
                            </div>
                            <div style={{textAlign: 'center', marginTop: 30}}>
                                <div className="btn btn-primary" onClick={() => this.createUser()}>{t('salva')}</div>
                            </div><br/>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const backView = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowX: 'hidden', 
    overflowY: 'scroll',
};

const mainView = {
    width: '60%', 
    position: 'abolsute',
    marginLeft: '20%', 
    marginTop: '120px', 
    minHeight: 200,
    paddingBottom: '20px',
    backgroundColor: 'white', 
    borderRadius: '10px', 
    textAlign: 'center',
    boxShadow: '0px 2px 10px darkgrey',
}